import { NIKE_API_CALLER_ID } from 'nav-utilities';
import { URL } from '../../constants';

const CLOUDINARY_IMAGE_PARAM = `t_PDP_864_v1,f_auto,q_auto:eco`;
const CMS_COLLECTION_GROUP = 'd9a5bc42-4b9c-4976-858a-f159cf99c647';
const MEMBER_EXCLUSIVE_ID = `698d17bc-daf4-42d9-aee7-15841c59798c`;

const createQueryParams = (language, country, styleColors) => {
  const marketplace = country === 'au' ? 'ASTLA' : country.toUpperCase();
  const languageFilter = `filter=language(${language})`;
  const marketplaceFilter = `filter=marketplace(${marketplace})`;
  const channelIdFilter = `filter=channelId(${CMS_COLLECTION_GROUP})`;
  const styleColorFilter = `filter=productInfo.merchProduct.styleColor(${styleColors.join(`,`)})`;

  return `${languageFilter}&${marketplaceFilter}&${channelIdFilter}&${styleColorFilter}`;
};

function productThreadReducer(out, thread, index, cloudUrlFragment) {
  const { productCard, title, subtitle, seo, products } = thread.publishedContent.properties;

  // Skip this product if no productCard info is attached.
  if (!productCard) {
    return out;
  }
  const {
    properties: { portraitURL, squarishURL },
  } = productCard;
  const [productInfo] = thread.productInfo;
  const {
    merchPrice: { currentPrice, discounted, fullPrice, currency },
    merchProduct: { styleType },
  } = productInfo;

  const [product] = products;

  const isNikeByYou = styleType === `NIKEID`;
  const isMemberExclusive = thread.collectionsv2.collectionTermIds.includes(MEMBER_EXCLUSIVE_ID);
  const data = {
    id: index,
    copy: {
      title,
      subtitle,
    },
    globalProductId: thread.id,
    prices: {
      currency,
      currentPrice,
      initialPrice: fullPrice,
      discountPercentage: discounted
        ? Math.round(((fullPrice - currentPrice) / fullPrice) * 100)
        : 0,
    },
    colorwayImages: {
      squarishURL: squarishURL.replace(`t_default`, CLOUDINARY_IMAGE_PARAM),
      portraitURL: portraitURL ? portraitURL.replace(`t_default`, CLOUDINARY_IMAGE_PARAM) : null,
    },
    pdpUrl: {
      url: cloudUrlFragment
        ? `${URL.BASE}/${cloudUrlFragment}/t/${seo.slug}/${product.styleColor}`
        : `${URL.BASE}/t/${seo.slug}/${product.styleColor}`,
    },
    featuredAttributes: [
      ...(isNikeByYou ? [`CUSTOMIZED`] : []),
      ...(isMemberExclusive ? [`MEMBER_EXCLUSIVE`] : []),
    ],
  };
  return out.concat(data);
}

const fetchProductFeeds = async ({ country, language, logger, styleColors, cloudUrlFragment }) => {
  try {
    const queryParams = createQueryParams(language, country, styleColors);
    const url = `${URL.PRODUCT_FEEDS}?${queryParams}`;
    const options = {
      method: 'GET',
      headers: {
        'nike-api-caller-id': NIKE_API_CALLER_ID,
      },
    };
    const response = await fetch(url, options);
    const data = await response.json();
    const products = data.objects.reduce(
      (out, thread, index) => productThreadReducer(out, thread, index, cloudUrlFragment),
      [],
    );

    // Sort products to maintain the order from styleColors
    const sortedProducts = styleColors
      .map(styleColor => products.find(product => product.pdpUrl.url.endsWith(`/${styleColor}`)))
      .filter(Boolean); // Remove undefined entries if any styleColor wasn't found

    return sortedProducts;
  } catch (error) {
    logger.error('Error fetching data:', error);
    return null;
  }
};

export default fetchProductFeeds;
